{
	"dialog": {
		"yes": "Tak",
		"no": "Nie"
	},
	"common": {
		"username": "Nazwa użytkownika",
		"first-name": "Imię",
		"last-name": "Nazwisko",
		"optional": "opcjonalne",
		"cancel": "Anuluj",
		"back": "Wstecz",
		"skip": "Pomiń",
		"save": "Zapisz",
		"search": "Szukaj"
	},
	"contacts-select": {
		"input-search-labe": "Znajdź kontakty",
		"list-title": "Wszystkie kontakty"
	},
	"stepper": {
		"steps-of-total": "{{completed}} z {{total}}"
	},
	"profile-photo-picker": {
		"change-photo": "Zmień zdjęcie",
		"replace-photo": "Zastąp zdjęcie",
		"upload-photo": "Prześlij zdjęcie"
	},
	"editable-items": {
		"add-information": "Dodaj informacje"
	},
	"edit-profile-form": {
		"critical": "Krytyczne",
		"negative": "Negatywne",
		"positive": "Pozytywne",
		"tooltip": {
			"critical": "Informacje istotne dla zapewnienia bezpiecznej i odpowiedniej opieki",
			"positive": "Zainteresowania i upodobania osoby potrzebującej opieki, aby zapewnić spersonalizowaną opiekę",
			"negative": "Rzeczy, o których należy pamiętać, aby uniknąć dyskomfortu"
		},
		"email": "Email",
		"about-me": "O mnie",
		"restricted-access": "Ograniczony dostęp"
	},
	"crop-photo-modal": {
		"move-and-scale-the-photo": "Przesuwaj i skaluj, aby wybrać obszar zdjęcia, którego chcesz użyć.",
		"title": "Dostosuj obszar zdjęcia"
	},
	"table": {
		"no-data": "Brak danych"
	},
	"error-boundary": {
		"whoops-something-went-wrong": "Ups, coś poszło nie tak.",
		"please-either-refresh-the-page-or-try-again-later": "Proszę odświeżyć stronę lub spróbować ponownie później.",
		"refresh": "Odświeżyć?"
	},
	"autocomplete-input": {
		"placeholder": "Pisz, aby wyszukać",
		"add-value": "Dodaj „{{value}}”"
	},
	"tags-editor": {
		"label": "Tagi",
		"placeholder": "Wpisz, aby wyszukać tagi",
		"add-tag": "Dodaj tag \"{{value}}\""
	},
	"form-period-control": {
		"period": {
			"day_one": "{{count}} dzień",
			"day_few": "{{count}} dni",
			"day_many": "{{count}} dni",
			"custom": "Niestandardowy"
		}
	}
}
